import styled from "@emotion/styled";

export const Wrapper = styled.div`
  margin: 0 auto;
`;
